import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

/**
 * Catch-all 404 page rendered by the `path: '*'` route. Lives as a child of
 * the root layout so the sidebar + top bar stay mounted around it — the
 * user is still inside the app shell, not on a bare error page.
 */
export function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Page not found</CardTitle>
          <CardDescription>
            The page you were looking for doesn&apos;t exist or has moved.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex gap-2">
          <Button
            onClick={() => {
              void navigate(-1);
            }}
            variant="outline"
          >
            Go back
          </Button>
          <Button
            onClick={() => {
              void navigate('/');
            }}
          >
            Go to dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
